import { useEffect, useEffectEvent } from 'react'
import { useSelector } from '@/libs/state'
import { listMessages } from '../application/list-messages'
import { markRead } from '../application/mark-read'
import { activeTopicId$, messages$ } from '../store'
import { chat as chatPort, notify } from '../wiring'

const POLL_MS = 3000
const PAGE = 50

// The active conversation's messages. Like the conversation list, polling is the
// realtime seam (swap for SSE later with no UI change). On every load the read
// watermark is advanced to the newest message so the unread badge clears.
const useActiveThread = (topicId: string | null) => {
	const messages = useSelector(messages$)

	const reload = useEffectEvent(async () => {
		if (!topicId) {
			messages$.set([])
			return
		}
		const loaded = await listMessages(chatPort, topicId, 0, PAGE, notify)
		// Backend returns newest-first; render oldest-first.
		const ordered = [...loaded].reverse()
		messages$.set(ordered)
		const newest = ordered.at(-1)
		if (newest) await markRead(chatPort, topicId, newest.seqId)
	})

	useEffect(() => {
		activeTopicId$.set(topicId)
		reload()
		if (!topicId) return
		const timer = setInterval(reload, POLL_MS)
		return () => clearInterval(timer)
	}, [topicId])

	return { messages, reload }
}

export { useActiveThread }
